
function Responsive() {
    var controllerSelector = '[data-pf-controller="responsiveControl"]';
    var activeClass = 'is-active';
    var responsiveIframeName = 'pf-responsive-iframe';

    const responsiveControls = Array.from(document.querySelectorAll(controllerSelector));
    responsiveControls.forEach((button) => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            var container = document.getElementById('main');
            var responsiveIframe = document.getElementsByName(responsiveIframeName).item(0);

            var page = window.location.href;
            var mode = button.dataset.responsiveMode;
            var width, iframe;

            if (mode === undefined) {
                return;
            }

            // Remove classes from all buttons
            responsiveControls.forEach((control) => {
                control.classList.remove(activeClass);
            });

            // Add active class to clicked button
            button.classList.add(activeClass);

            // Switch width
            if (mode === 'tablet') {
                width = 768;
            } else if (mode === 'mobile') {
                width = 338; // 320 + 18 to compensate for scrollbar
            } else {
                // Desktop, just reload
                window.location.reload();
                return;
            }

            if (responsiveIframe) {
                // We have an iframe already
                iframe = responsiveIframe;
            } else {
                // We haven't got an iframe already, setup the page
                iframe = createElementFromHTML('<iframe frameborder="0" height="100%" width="100%" name="' + responsiveIframeName + '" class="pf-responsive-iframe">');
                container.replaceChildren();
                container.append(iframe);

                // Add classes
                document.body.classList.add('is-responsive-mode');
                container.classList.add('pf-content--responsiveMode');

                // Load the page
                iframe.src = page;

                // Set an onLoad listener
                iframe.onload = function() {
                    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
                    iframeDoc.body.classList.add('in-responsive-mode');
                };

                // specifically for MSIE and FF to load content in iframe
                window.frames[responsiveIframeName].location = page;
            }

            // Set width, is animated by CSS
            iframe.style.width = width + 'px';
        });
    });
}

function createElementFromHTML(htmlString) {
    const div = document.createElement('div');
    div.innerHTML = htmlString.trim();
    return div.firstChild;
}

module.exports = new Responsive();
